import { render, staticRenderFns } from "./AddonAssignCompany.vue?vue&type=template&id=813e729e&"
import script from "./AddonAssignCompany.vue?vue&type=script&lang=js&"
export * from "./AddonAssignCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports